import "htmx.org/dist/htmx.esm.js"
import htmx from "htmx.org/dist/htmx.esm.js"
// import * as htmx from "htmx.org/dist/htmx.js";
import "./dn-autoloader.js"
import "./htmx-ext-shoelace.js"
import { discover, initialDiscover } from "./dn-autoloader.js"
import "./components/dn-affiliate-referral/dn-affiliate-referral.js"
import { drivenowEnvironment, drivenowOxideVersion } from "./utilities/env.js"
import { BrowserMicroSentryClient, type MicroSentryPlugin } from "@micro-sentry/browser"
import { BreadcrumbsPlugin } from "@micro-sentry/breadcrumbs-plugin"
import { openCustomerAssistance } from "../assistance-ui/launcher.js"
import { initDebugToolsFromLocalStorageGate } from "./utilities/debug-tools.js"
import { installSiteSearchTracking } from "./utilities/site-search-tracking.js"
import {
  showCurrentPageSearchWidget,
} from "./utilities/current-page-search-widget.js"
import Cookies from "js-cookie"

function safeJoin(input: unknown[], delimiter = ' '): string {
  if (!Array.isArray(input)) {
    return ''
  }
  return input
    .map((value) => {
      try {
        return String(value)
      } catch (e) { }
      try {
        return Object.prototype.toString.call(value)
      } catch (e) { }
      return ''
    })
    .filter((v) => v)
    .join(delimiter)
}

/*
Plugin to capture a message when a console.error occurs
*/
class CaptureConsoleErrorPlugin implements MicroSentryPlugin {

  constructor(readonly client: BrowserMicroSentryClient) {
    let console_error = console.error
    console.error = (...args: any[]) => {
      console_error(...args)
      let message = safeJoin(["console.error", ...args], ' ')
      this.client.captureMessage(message)
    }
  }

}
const client = new BrowserMicroSentryClient({
  dsn: 'https://f3218f4faf1b43b198e5539b1365f3c8@o43168.ingest.us.sentry.io/93944',
  plugins: [BreadcrumbsPlugin, CaptureConsoleErrorPlugin],
  release: drivenowOxideVersion(),
  environment: drivenowEnvironment() ?? "dev",
  ignoreErrors: [new RegExp("olark")]
})

// import { captureException, captureEvent, breadcrumbsIntegration, browserApiErrorsIntegration, dedupeIntegration, globalHandlersIntegration, init as sentryInit, linkedErrorsIntegration, captureMessage } from "@sentry/browser";
// sentryInit({
//   dsn: "https://f3218f4faf1b43b198e5539b1365f3c8@o43168.ingest.us.sentry.io/93944",
//   environment: drivenowOxideEnvironment() ?? "dev",
//   integrations: [
//     breadcrumbsIntegration(),
//     globalHandlersIntegration(),
//     linkedErrorsIntegration(),
//     dedupeIntegration(),
//     browserApiErrorsIntegration(),
//   ],
// });
window.MicroSentry = client

const shouldInjectRemoteDebugger = () => {
  let devtools = new URLSearchParams(window.location.search).get("devtools")
  let cdpEnabled = devtools === "cdp"
  return cdpEnabled && Cookies.get("isAdmin") === "true"
}

const injectRemoteDebugger = () => {
  if (!shouldInjectRemoteDebugger()) {
    return
  }

  if (document.getElementById("oxide-remote-debugger")) {
    return
  }

  let script = document.createElement("script")
  script.src = "https://devtools-remote-debugger.drivenow.com.au/remote/debug/dist/cdp.js"
  script.async = true
  script.id = "oxide-remote-debugger"
  script.setAttribute("data-metadata", JSON.stringify({
    frontendName: "oxide",
    frontendVersion: drivenowOxideVersion(),
    environment: drivenowEnvironment(),
    username: Cookies.get("username"),
  }))
  document.head.appendChild(script)
}

initDebugToolsFromLocalStorageGate()
injectRemoteDebugger()

if (Element.prototype["getAnimations"] === undefined) {
  Element.prototype.getAnimations = function () {
    return []
  }
}

// htmx.logAll();
(htmx.config as any).selfRequestsOnly = false

type CssModule = {
  id: string
  css: string
}
async function loadCssModules(elt: HTMLElement, module_ids: string[]) {
  let root = elt.getRootNode() as Document | ShadowRoot
  let el: HTMLHeadElement | ShadowRoot
  if ("head" in root) {
    el = root.head
  } else {
    el = root
  }

  // filter out existing
  module_ids = module_ids.filter((id) => {
    return !el.querySelector(`style[sass-module-id="${id}"]`)
  })

  if (module_ids.length === 0) {
    return
  }

  let cssModulesVersion = drivenowEnvironment() === "dev" ? Date.now().toString() : drivenowOxideVersion()

  // fetch them one by one in parallel to improve caching
  await Promise.all(module_ids.map(async (id) => {
    return fetch(`/oxide/pages/hx/sass-ssr/modules?v=${cssModulesVersion}&ids=${id}`)
      .then((res) => res.json())
      .then((res) => {
        res.forEach((module: CssModule) => {

          // detect duplicates (could be added by another htmx request in parallel)
          let existing = el.querySelector(`style[sass-module-id="${module.id}"]`)
          if (existing) {
            return
          }

          let style = document.createElement("style")
          style.setAttribute("sass-module-id", module.id)
          style.textContent = module.css
          el.appendChild(style)
        })
      })
  }))
}

document.body.addEventListener(
  "htmx:beforeSend",
  function (event: CustomEvent) {
    let xhr = event.detail.xhr
    let elt = event.detail.elt
    let _onload = xhr.onload
    xhr.onload = () => {
      let modules = xhr.getResponseHeader("dn-sass-modules")
      if (modules) {
        loadCssModules(elt, modules.split(",")).then(_onload).catch(_onload)
      } else {
        _onload()
      }
    }
  }
)

document.body.addEventListener("htmx:afterSwap", function (event: CustomEvent) {
  let target = event.detail.target
  discover(target)
})

// function createMorphConfig(swapStyle) {
//   if (swapStyle === 'morph' || swapStyle === 'morph:outerHTML') {
//       return {morphStyle: 'outerHTML'}
//   } else if (swapStyle === 'morph:innerHTML') {
//       return {morphStyle: 'innerHTML'}
//   } else if (swapStyle.startsWith("morph:")) {
//       return Function("return (" + swapStyle.slice(6) + ")")();
//   }
// }

// htmx.defineExtension('morph', {
//   isInlineSwap: function(swapStyle) {
//       let config = createMorphConfig(swapStyle);
//       return config.swapStyle === "outerHTML" || config.swapStyle == null;
//   },
//   handleSwap: function (swapStyle, target, fragment) {
//       let config = createMorphConfig(swapStyle);
//       if (config) {
//           return Idiomorph.morph(target, fragment.children, config);
//       }
//   }
// });

window["htmx"] = htmx
installSiteSearchTracking()

let viteReactRefreshReady = Promise.resolve()

if (import.meta.env.DEV) {
  // Vite normally injects the React refresh preamble into index.html automatically.
  // In this app, the HTML shell comes from the Rust server and React islands like
  // <dn-reloc-page> are loaded later via the custom dn-autoloader dynamic imports,
  // so Vite's normal HTML preamble injection path is bypassed. Install the dev
  // preamble manually so lazily imported .tsx modules don't fail with
  // "@vitejs/plugin-react can't detect preamble".
  viteReactRefreshReady = new Promise<void>((resolve, reject) => {
    const readyEvent = "dn-vite-react-refresh-ready"
    window.addEventListener(readyEvent, () => resolve(), { once: true })

    const preamble = document.createElement("script")
    preamble.type = "module"
    preamble.textContent = `
      import RefreshRuntime from ${JSON.stringify(`${import.meta.env.BASE_URL}@react-refresh`)}
      RefreshRuntime.injectIntoGlobalHook(window)
      window.$RefreshReg$ = () => {}
      window.$RefreshSig$ = () => type => type
      window.__vite_plugin_react_preamble_installed__ = true
      window.dispatchEvent(new Event(${JSON.stringify(readyEvent)}))
    `
    preamble.addEventListener("error", () => reject(new Error("React Fast Refresh preamble failed to load")), { once: true })
    document.head.append(preamble)
  })
}

const handleUrlHash = () => {

  let hashId = window.location.hash.substring(1)
  if (!hashId) {
    return
  }

  if (hashId === "search") {
    showCurrentPageSearchWidget()
    return
  }

  if (hashId === "chat") {
    openCustomerAssistance()
    return
  }


  let target = document.getElementById(hashId)
  if (target) {
    activate_target(target)
    return // browser will auto scroll to it
  }

  // loop until either
  // the user scrolls
  // the element is loaded
  // a timeout has passed

  let start = Date.now()
  let interval = setInterval(() => {

    // do this each time since the dn-vp-autoloader might not yet be listening
    // load the below-the-fold content  
    document.body.dispatchEvent(new CustomEvent('dn-viewport-autoloader-trigger-event', {
      detail: {
        trigger: "load-below-the-fold"
      }
    }))

    // console.log("waiting for " + hashId);
    let target = document.getElementById(hashId)
    if (target) {
      clearInterval(interval)

      activate_target(target)
      return
    }

    if (Date.now() - start > 5000) {
      // console.log("timeout, cancelling trying to scroll to " + hashId);
      clearInterval(interval)
    }
  }, 500)

  window.addEventListener("scroll", () => {
    // console.log("user scrolled, cancelling trying to scroll to " + hashId);
    clearInterval(interval)
  }, { once: true })

}

function activate_target(target: HTMLElement) {
  // console.log("found  " + hashId);
  target.scrollIntoView()
  // if the heading is in a <details> element, open it
  let details = target.closest("details")
  if (details) {
    details.open = true
  }
}


document.addEventListener("DOMContentLoaded", handleUrlHash)
window.addEventListener("hashchange", handleUrlHash)

// demoLlpFuturePriceChart()


// this MUST be defined before any components that use it otherwise the context provider and consumers won't work
viteReactRefreshReady
  .catch((error) => console.warn("React Fast Refresh could not be initialised", error))
  .then(() => initialDiscover())

setTimeout(async () => {
  let { trackWebVitals } = await import("./web-vitals.js")
  trackWebVitals()
}, 3000)
